import { Box, BoxProps, Container, Heading, Stack } from '@hover/blueprint';
import React, { FC } from 'react';
import NewsLetterForm from './NewsLetterForm';
import NewsLetterViewJobs from './NewsLetterViewJobs';
import NewsLetterContactUs from './NewsLetterContactUs';

interface Props extends BoxProps {
  iconColor?: string;
  showForm?: boolean;
  showViewJobs?: boolean;
}

const NewsLetterBar: FC<Props> = ({
  iconColor,
  showForm,
  showViewJobs,
  ...restProps
}) => (
  <Box bg="brandNavy.500" w="100%" {...restProps}>
    <Container
      maxW="1232px"
      overflow="hidden"
      py="88px"
      px={{ base: 500, tablet: '56px' }}
    >
      <Heading
        as="h2"
        isLight
        color="neutral.0"
        size={{ base: 500, tablet: 600, desktop: 700 }}
        width="80%"
        marginBottom={{ base: 500, tablet: '88px', desktop: '88px' }}
      >
        Stay in the know.
      </Heading>
      <Stack direction={{ base: 'column', desktop: 'row' }}>
        <Stack
          mb={700}
          mr={{ base: 0, desktop: '107px' }}
          direction={{ base: 'column', tablet: 'row' }}
          spacing={{ base: 500, desktop: '103px' }}
        >
          {showViewJobs ? (
            <NewsLetterViewJobs iconColor={iconColor ?? 'brandOrange.500'} />
          ) : null}
          <NewsLetterContactUs
            iconColor={iconColor ?? 'brandOrange.500'}
            w={{ base: '100%', desktop: showViewJobs ? '205px' : '270px' }}
          />
        </Stack>
        <Box flexDir="row">
          {showForm && (
            <NewsLetterForm iconColor={iconColor ?? 'brandOrange.500'} />
          )}
          <Box flex={{ base: 0, tablet: 1, desktop: 0 }} />
        </Box>
      </Stack>
    </Container>
  </Box>
);

NewsLetterBar.defaultProps = {
  iconColor: 'brandOrange.500',
  showForm: false,
  showViewJobs: true,
};

export default NewsLetterBar;
